import { IObjectified, Inline } from './utils';
import { IDocumentOutputOptionsFacade, IDocumentOutputOptionsDetailsResponse, INotificationFacade, IDocumentOutputFacade } from './swaggerTypes';
import { Api, toObjectified } from './baseApi';
import { Payload, usePost } from './reactQuery/queryService';
import { APIRoutes } from './constants';

export type ObjectifiedDocumentOutputOptionsDetailsResponse = Omit<IDocumentOutputOptionsDetailsResponse, 'DocumentOutputOptions'> & {
  DocumentOutputOptions: IObjectified<IDocumentOutputOptionsFacade>;
};

export async function updateOptions(options: IDocumentOutputFacade, SendDocument: boolean): Promise<ObjectifiedDocumentOutputOptionsDetailsResponse> {
  const params = new URLSearchParams('');
  params.set('SendDocument', SendDocument ? 'True' : 'False');

  return Api.postInlineCollectionResponse<IDocumentOutputFacade, IDocumentOutputOptionsDetailsResponse, 'DocumentOutputOptions'>(
    `DocumentOutput/ApplyDocumentOutputOptions?${params.toString()}`, options)
    .then((response) => ({
      ...response,
      DocumentOutputOptions: response.DocumentOutputOptions ? toObjectified(response.DocumentOutputOptions) : undefined
    }));
}

export const useUpdateOptions = () => {

  return usePost<Payload<{ urlQueryParams: { SendDocument: boolean } } & IDocumentOutputFacade>, ObjectifiedDocumentOutputOptionsDetailsResponse>
    (APIRoutes.DocumentOutput.apply, null, { inline: true, responseParser: DocumentOutputOptionsDetailsResponseParser });
};

const DocumentOutputOptionsDetailsResponseParser = (response) => {
  const { DocumentOutputOptions } = response;

  return {
    ...response,
    DocumentOutputOptions: DocumentOutputOptions ? toObjectified(DocumentOutputOptions as Inline<IDocumentOutputOptionsFacade>) : null
  };
};

export const useSendNotification = () =>
  usePost<Payload<INotificationFacade>, ObjectifiedDocumentOutputOptionsDetailsResponse>(
    APIRoutes.DocumentOutput.Notification.Send,
    null,
    { inline: true, responseParser: DocumentOutputOptionsDetailsResponseParser }
  );

export const useSetDefaultOptions = () => {

  return usePost<Payload<{ DocumentType: string; FieldId: string } & {
    documentCode: string;
    entityCode: string;
    keyId: string;
    businessObjectId: string;
  }>, ObjectifiedDocumentOutputOptionsDetailsResponse>
    (APIRoutes.DocumentOutput.defaultOptions.retrieve, null, { inline: true, responseParser: DocumentOutputOptionsDetailsResponseParser });
};
